// Zelle der Berechnungszeile unter einer Spalte (Agent 10B, Runde 10): „+ Berechnung“ oder „Summe 15“, Klick öffnet die Rechenarten
// der Spalte (nach Typ), die gewählte trägt einen Haken, unten „Berechnung entfernen“.
import { Icon } from "../Icon";
import { MenueKnopf, type MenuePunkt } from "../Menue";
import {
  FUNKTIONS_GRUPPEN,
  FUNKTION_KURZ,
  FUNKTION_NAME,
  ergebnisLang,
  ergebnisText,
  funktionenFuer,
  type BerechnungsErgebnis,
  type BerechnungsFunktion,
} from "./berechnungModell";
import "./berechnung.css";

interface Props {
  /** Überschrift der Spalte (für Tooltip und Vorlesen) */
  label: string;
  /** Typ der Spalte im Katalog; ohne Typ oder ohne Rechenarten bleibt die Zelle leer */
  typ: string | undefined;
  funktion: BerechnungsFunktion | undefined;
  ergebnis: BerechnungsErgebnis | undefined;
  /** Es wird gerade (neu) gerechnet */
  laedt: boolean;
  /** Anzahl der Treffer, über die gerechnet wird (für den Tooltip), und ob der Server gekappt hat */
  anzahl: number | null;
  gekappt: boolean;
  onWaehlen: (f: BerechnungsFunktion | null) => void;
}

export function BerechnungsZelle({ label, typ, funktion, ergebnis, laedt, anzahl, gekappt, onWaehlen }: Props) {
  const erlaubt = funktionenFuer(typ);
  if (!erlaubt.length) return null;

  const punkte: MenuePunkt[] = [];
  for (const g of FUNKTIONS_GRUPPEN) {
    const dabei = g.funktionen.filter((f) => erlaubt.includes(f));
    if (!dabei.length) continue;
    punkte.push({ label: g.titel, ueberschrift: true, trenner: punkte.length > 0 });
    for (const f of dabei) {
      punkte.push({ label: FUNKTION_NAME[f], onClick: () => onWaehlen(f), rechts: f === funktion ? <Icon name="haken" groesse={14} /> : undefined });
    }
  }
  if (funktion) punkte.push({ label: "Berechnung entfernen", icon: "schliessen", onClick: () => onWaehlen(null), trenner: true });

  const aktuell = funktion && ergebnis && ergebnis.funktion === funktion ? ergebnis : undefined;
  const bezug = anzahl === null ? "" : gekappt ? ` (über die ersten ${anzahl.toLocaleString("de-DE")} Treffer)` : ` (über ${anzahl.toLocaleString("de-DE")} Treffer)`;
  const titel = funktion ? `${ergebnisLang(label, aktuell, funktion)}${bezug}. Klicken, um die Berechnung zu ändern.` : `${label}: Berechnung hinzufügen`;

  return (
    <MenueKnopf
      knopfKlasse={`berechnung__knopf${funktion ? " berechnung__knopf--an" : ""}${laedt && funktion ? " berechnung__knopf--laedt" : ""}`}
      titel={titel}
      punkte={punkte}
      breite={220}
    >
      {funktion ? (
        <>
          <span className="berechnung__art">{FUNKTION_KURZ[funktion]}</span>
          <span className="berechnung__wert">{aktuell ? ergebnisText(aktuell) : laedt ? "…" : "–"}</span>
        </>
      ) : (
        <>
          <Icon name="plus" groesse={12} />
          <span className="berechnung__neu">Berechnung</span>
        </>
      )}
    </MenueKnopf>
  );
}
